import { Component } from '@angular/core';

@Component({
  selector: 'mc-add-manually',
  imports: [],
  templateUrl: './add-manually.html',
  styleUrl: './add-manually.scss',
})
export class AddManually {

}
